import { lazy } from 'react'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const RootPage = lazy(() => import('modules/profile/pages/employees/RootPage'))
const ProtectedTerminatePage = lazy(() => import('modules/employees/pages/ProtectedTerminatePage'))

const employeesRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: '',
      element: <RootPage />,
      children: [
        {
          path: navigation.employees.id.terminate.path,
          element: <ProtectedTerminatePage />,
        },
      ],
    },
  ]
}

export default employeesRoutes
